export const PERIODS = ["week", "month", "all"] as const;
export type Period = (typeof PERIODS)[number];

/** Start of the period as ISO, null for all time */
export const periodStart = (period: Period, now: Date): string | null => {
  if (period === "all") return null;
  const days = period === "week" ? 7 : 30;
  return new Date(now.getTime() - days * 24 * 3600_000).toISOString();
};

/** Share as a whole percent; null when there is nothing to divide by */
export const percent = (part: number, total: number) =>
  total > 0 ? Math.round((100 * part) / total) : null;

/** Minutes in the coarsest readable unit */
export const reactionParts = (minutes: number | null) => {
  if (minutes == null) return null;
  if (minutes < 60)
    return { count: Math.round(minutes), unit: "minutes" as const };
  if (minutes < 24 * 60)
    return { count: Math.round(minutes / 60), unit: "hours" as const };
  return { count: Math.round(minutes / (24 * 60)), unit: "days" as const };
};
